// The platform identity is a text wordmark alongside the official Haramain mark.
export const Logo = ({ variant = "dark", textSize = "text-2xl" }) => {
  const light = variant === "light";
  const textColor = light ? "text-white" : "text-[#25343f]";
  return (
    <div className="masar-logo">
      <span className={`masar-name font-semibold ${textSize} ${textColor}`}>مسار التميز</span>
    </div>
  );
};
